import reportTypesRaw from '../response/report-types.json';
import plasticTypesList from '../response/plastic-types-list.json';
import plasticType from '../response/plastic-type.json';
import { Response } from 'miragejs';
import vehicleType from '../response/vehicle-type.json';
import cardUsageFavourites from '../response/card-usage-favourites.json';
import Env from 'Env';

export default function DataStoreRoutes() {
  // Get Report Types
  this.get('store-api/v1/reporttype', () => {
    // Feature flag: Hide EV Way4 reports when flag is disabled
    const reportTypes = Env.getIsEvWay4Enabled()
      ? reportTypesRaw
      : reportTypesRaw.filter((r) => r.reportTypeId !== '24');
    return reportTypes;
  });

  // Get Plastic Types List
  this.get('store-api/v1/plastictype', () => plasticTypesList);

  // Get Plastic Type by Id
  this.get('store-api/v1/plastictype/:id', () => plasticType);

  // Create Plastic Type
  this.post('store-api/v1/plastictype', (schema, request) => {
    const { id } = JSON.parse(request.requestBody);

    if (id === 'A_231') {
      return new Response(409, {}, { errorMessage: 'Plastic type A_231 already exists' });
    }

    return new Response(200);
  });

  // Update Plastic Type
  this.put('store-api/v1/plastictype/:id', () => {});

  // Get Vehicle Type
  this.get('/store-api/v1/vehicletype', () => vehicleType);

  // Get Card Usage Options Favourites
  this.get('/store-api/v1/cardoptions/favourite/account/:accountID', () => cardUsageFavourites);
}
